import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=1c836c9a&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=1c836c9a&prod&lang=less&"
import style1 from "./Collapse.vue?vue&type=style&index=1&id=1c836c9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c836c9a",
  null
  
)

export default component.exports